import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    expandLabelGroup: (groupName: string) => string | React.ReactNode;
    emoji: string;
    groupMembersCount: (count: number) => string | React.ReactNode;
    syncingGroup: string;
    labelRole: (groupName: string) => string | React.ReactNode;
    labelAuthedUser: string;
    pending: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for button to expand and show members of a user group */
            expandLabelGroup: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (groupName: string) => __intl__.intl().formatMessage({ id: "InviteAccessMemberWithMembers.expandLabelGroup?c=2cc12wacoutm7", defaultMessage: "Show group members for {groupName}" }, { groupName: groupName }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessibility text for emoji icon */
            emoji: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InviteAccessMemberWithMembers.emoji?c=3blfr39u4hcib", defaultMessage: "Emoji" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text showing count of group members */
            groupMembersCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "InviteAccessMemberWithMembers.groupMembersCount?c=1qq8nffpqwimx", defaultMessage: "{count, plural, one {1 Group member} other {{count} Group members}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Status text indicating group is currently syncing */
            syncingGroup: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InviteAccessMemberWithMembers.syncingGroup?c=201ytxc7adbzs", defaultMessage: "Syncing group" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for role selection dropdown for a user group */
            labelRole: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (groupName: string) => __intl__.intl().formatMessage({ id: "InviteAccessMemberWithMembers.labelRole?c=3rnkucxpks9ad", defaultMessage: "Change role for {groupName}" }, { groupName: groupName }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label indicating current authenticated user */
            labelAuthedUser: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InviteAccessMemberWithMembers.labelAuthedUser?c=33hg9nvaytt5x", defaultMessage: "(you)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for pending (not yet accepted invite) user */
            pending: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InviteAccessMemberWithMembers.pending?c=1hdx1m8rhv786", defaultMessage: "Pending User" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
